import { create } from 'zustand';
import { api, type Department } from '../lib/api';

interface DepartmentState {
  departments: Department[];
  loaded: boolean;
  /** Fetches the department list (with counts); safe to call repeatedly. */
  refresh: () => Promise<void>;
}

export const useDepartmentStore = create<DepartmentState>((set) => ({
  departments: [],
  loaded: false,
  refresh: async () => {
    try {
      const { departments } = await api.departments();
      set({ departments, loaded: true });
    } catch {
      set({ loaded: true });
    }
  },
}));

/** Display name for a department id, falling back to "General". */
export function useDepartmentName(): (id: string) => string {
  const departments = useDepartmentStore((s) => s.departments);
  return (id: string) => departments.find((d) => d.id === id)?.name ?? 'General';
}
